import { useCallback, useEffect, useState } from "react";

export type OnboardingStatus = {
  is_ad_settings_done: boolean;
  is_basic_info_done?: boolean;
  is_marketing_done?: boolean;
  is_tech_req_done?: boolean;
  is_budget_done: boolean;
  is_external_link_done: boolean;
  is_ad_account_linked: boolean;
  is_completed: boolean;
};

export const useOnboardingStatus = (projectId: number | null | undefined) => {
  const [status, setStatus] = useState<OnboardingStatus | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchStatus = useCallback(async () => {
    if (!projectId) {
      setStatus(null);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/get-onboarding-status?project_id=${projectId}`,
        { credentials: "include" }
      );
      if (!res.ok) {
        const body = await res.json().catch(() => null);
        throw new Error(body?.detail || body?.error || "オンボーディング状況の取得に失敗しました。");
      }
      const json = await res.json();
      setStatus((json?.data as OnboardingStatus) ?? null);
    } catch (e: any) {
      setError(e.message ?? "オンボーディング状況の取得に失敗しました。");
      setStatus(null);
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return { status, loading, error, refetch: fetchStatus };
};
